import usePrivateAxios from '@/common/api/usePrivateAxios'
import { useMutation } from '@tanstack/react-query'

interface UseDeletePublicCompanyLeadContractFeeProps {
  publicCompanyLeadId?: string
  onSuccess: () => void
  onError: () => void
}

export const useDeletePublicCompanyLeadContractFee = ({
  publicCompanyLeadId,
  onSuccess,
  onError,
}: UseDeletePublicCompanyLeadContractFeeProps) => {
  const privateAxios = usePrivateAxios()

  return useMutation({
    mutationKey: ['deletePublicCompanyLeadContractFee'],
    mutationFn: async (id: string) => {
      const lead = {
        contract_attributes: {
          contract_fees_attributes: [
            {
              id,
              _destroy: true,
            },
          ],
        },
      }

      await privateAxios.putForm(`/funnel/public/leads/${publicCompanyLeadId}`, {
        lead,
      })
    },
    onSuccess,
    onError,
  })
}
